import { useQuery } from 'react-query';
import { useAPIRoute } from '../../hooks/useAPIRoute';
import { Model } from 'rwl-shared';

type UseFetchJobDetailsParams = {
    accountId: string;
    jobId: string | undefined;
    showcaseOnly?: boolean;
};

export const useFetchJobDetails = ({
    accountId,
    jobId,
    showcaseOnly,
}: UseFetchJobDetailsParams) => {
    const url = useAPIRoute('job/' + jobId);

    return useQuery<Model.PluginJobDetails | undefined>(
        ['job', accountId, 'job', jobId, showcaseOnly],
        async () => {
            if (!jobId) {
                return undefined;
            }
            const result = await fetch(
                `${url}?` +
                    new URLSearchParams({
                        accountId: accountId,
                        showcaseOnly: showcaseOnly?.toString() ?? '',
                    }),
                {
                    method: 'GET',
                }
            );
            return result.json();
        },
        {
            staleTime: 1000 * 60 * 60 * 24, // 24 hours
        }
    );
};
